import { render } from "./MedicineTab.vue?vue&type=template&id=5a2e6789"
import script from "./MedicineTab.vue?vue&type=script&lang=js"
export * from "./MedicineTab.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/kolos-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__